import { ECommerce } from "ui/forms/Onboarding";
import { Step, withStepData } from "ui/organizms/Onboarding/Applications/common";
import usePaymentMethods from "./usePaymentMethods";

const PaymentMethods = () => {
    const paymentMethods = usePaymentMethods();

    return (
        <Step
            title='Payment Methods'
        >
            <ECommerce.PaymentMethods.Form
                {...paymentMethods}
            />
        </Step>
    );
};

export default withStepData(PaymentMethods);
